import { MODALS_ENUM } from '@constants/Modals';
import { AddRackTemplate_RequestTypes, DeleteRackTemplate_RequestTypes, EditRackTemplate_RequestTypes, GetRackTemplatesList_RequestTypes } from '@mobx/api/locations';
import { IRackModal3PropsBase } from '@mobx/components/RackModal3';
import apiService, { createStore, RequestControl, withLoading } from '@mobx/services/http';
import { UserRole } from '@services/http/responses/AccountResponse';
import store_ from '@store';
import { makeAutoObservable, runInAction } from 'mobx';
import { show } from 'redux-modal';
import { getGlobalIntl } from '../../../i18n/ProviderIntl';
import { IRackSection3, IRackTemplate } from './types';

const createRackTemplatesStore_ = (rc: RequestControl) => {
  const deleteTemplate = apiService.createRequest(DeleteRackTemplate_RequestTypes);
  const addTemplate = apiService.createRequest(AddRackTemplate_RequestTypes);
  const editTemplate = apiService.createRequest(EditRackTemplate_RequestTypes);
  const getTemplates = apiService.createRequest(GetRackTemplatesList_RequestTypes);

  const self = {
    isLoading: false,
    templates: [] as IRackTemplate[],

    delete(id: string) {
      return new Promise<boolean>(resolve => {
        const { formatMessage } = getGlobalIntl();
        const onConfirm = async () => {
          const res = await withLoading(self, deleteTemplate(rc.createRequestHandle(), id));
          if (!res) {
            resolve(false)
            return;
          }
          runInAction(() => {
            self.templates = self.templates.filter(t => t.id !== id);
          });
          resolve(true);
        };

        const modalTitle = formatMessage({id: "location.rackTable.rack_template.sure_delete"});

        store_()?.dispatch(
          show(MODALS_ENUM.CONFIRM_MODAL, {
            title: modalTitle,
            onConfirm,
          })
        );      
      })
    },

    showRackModalForEdit(rt: IRackTemplate) {
      const props: IRackModal3PropsBase = { rackTemplate: rt };
      store_()?.dispatch(
        show(MODALS_ENUM.RACK_MODAL_MOBX, props)
      );
    },

    showRackModalForCreating() {
      const props: IRackModal3PropsBase = {
        hideRackId: true,
      };
      store_()?.dispatch(
        show(MODALS_ENUM.RACK_MODAL_MOBX, props)
      ); 
    },

    async createRackTemplate(sections: IRackSection3[], width: number, height: number) {
      const r = await withLoading(self, addTemplate(rc.createRequestHandle(), sections, width, height));
      if (!r) return false;
      runInAction(() => {
        self.templates = [
          ...self.templates, 
          {
            id: r.Record,
            rack_type: [width, height],
            rack_items: sections,
          }
        ];
      });
      return true;
    },

    async editRackTemplate(templateID: string, sections: IRackSection3[], width: number, height: number) {
      const r = await withLoading(self, editTemplate(rc.createRequestHandle(), templateID, sections, width, height));
      if (!r) return false;
      runInAction(() => {
        self.templates = self.templates.map(t => t.id === templateID ? {
          id: templateID,
          rack_items: sections,
          rack_type: [width, height],
        } : t);
      });
      return true;
    },

    async init(role?: UserRole) {
      if (role !== UserRole.Admin) {
        self.templates = [];
        return;
      }
      const r = await withLoading(self, getTemplates(rc.createRequestHandle()));
      if (!r) return;
      runInAction(() => {
        self.templates = r.Records;
      })
    },
  };

  return makeAutoObservable(self);
}

const rackTemplatesStore = createStore(createRackTemplatesStore_);
export default rackTemplatesStore;
